export default __webpack_public_path__ + "2b6005318dc5f4fcd2a7874d285df91b.svg";